import tailwindColors from "../../../../../tailwind.colors";

export const TRIPLO_HAPLO = "triplo_haplo";
export const TRIPLO = "triplo";
export const HAPLO = "haplo";
export const NORMAL = "normal";

const NCE = "non_coding_exon";
const UTR5 = "five_prime_UTR";
const UTR3 = "three_prime_UTR";

export const sequenceTypeIndex = {
  [NCE]: 0,
  [UTR5]: 1,
  [UTR3]: 2,
  //
  [NORMAL]: 3,
  [HAPLO]: 4,
  [TRIPLO]: 5,
  [TRIPLO_HAPLO]: 6,
};

export function calcTriploHaplo(transcript) {
  if (transcript.triploSenScore && transcript.haploInsScore) {
    return sequenceTypeIndex[TRIPLO_HAPLO];
  }
  if (transcript.haploInsScore) {
    return sequenceTypeIndex[HAPLO];
  }
  if (transcript.triploSenScore) {
    return sequenceTypeIndex[TRIPLO];
  }
  return sequenceTypeIndex[NORMAL];
}

export const sequenceRgbIndex = [0, 1, 1, 2, 3, 4, 5];

export const sequenceWidths = [14, 14, 14, 20];
export const mainColor = tailwindColors.blue[500];

export const sequenceColors = [
  tailwindColors.blue[400],
  tailwindColors.emerald[500],
  tailwindColors.emerald[400],
  tailwindColors.blueGray[400],
];
